import { render, staticRenderFns } from "./nav-links.vue?vue&type=template&id=77a4471a&"
import script from "./nav-links.vue?vue&type=script&lang=js&"
export * from "./nav-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports